module.exports = __webpack_public_path__ + "img/sticker_18.aa8413d6.svg";